import React from 'react';

import { AuthProvider } from './auth';
import { BottomSheetProvider } from './bottomSheet';
import { InvoiceProvider } from './invoice';
import { ToastProvider } from './toast';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <InvoiceProvider>
      <ToastProvider>
        <BottomSheetProvider>{children}</BottomSheetProvider>
      </ToastProvider>
    </InvoiceProvider>
  </AuthProvider>
);

export default AppProvider;
